/*
  Lily & June shipping protection (operator 27-10-2026): the Essential Cart Drawer toggle "Shipping protection" ($4.95)
  is ON by default and never shows as a line in the cart. When the first piece goes in, this switches the app's own
  toggle on once; if the shopper switches the toggle off it stays off for that cart (cart attribute
  _lj_protect_off). The drawer line of that product is hidden (layout/theme.liquid CSS); the toggle shows the state.
  Not counted for the quantity discount: the app product is type 'Order Upsell', outside collection all-jewelry and the bar.
  Old carts may still hold the separate 'shipping-protection' product from the first version of 27-10: it is removed.
*/
(function () {
  if (window.__ljProtect) return;
  window.__ljProtect = true;
  // 01-11 (review #6): the ids come from the app's own config in the page (<essential-cart-app-embed upsell-app-data="…">),
  // so a re-created app product or a new upsell id never leaves the shopper without protection. The literals are the
  // 27-10 values, used only when that element is missing or unreadable.
  var VID = 55556653384007;      // essential-cart-order-upsell-default (the app's toggle product)
  var OLD = 55502111473991;      // shipping-protection (cart line, 27-10 first version; product is DRAFT since 01-11)
  var PROPS = { __essential_cart_drawer_order_upsell_id: '7d10bec0-473c-45f5-bcdd-2f24aa3a62e7', __essential_cart_drawer_upsell_id: '516de2b3-b3ae-4796-a49e-6636b48e714a' };
  function readAppConfig() {
    try {
      var el = document.querySelector('essential-cart-app-embed[upsell-app-data]');
      if (!el) return;
      var cfg = JSON.parse(el.getAttribute('upsell-app-data'));
      var up = (cfg.orderUpsells || []).filter(function (u) { return u.isEnabled !== false && u.shopifyVariantId; })[0];
      var cart = (cfg.carts || [])[0];
      if (!up) return;
      var vid = parseInt(String(up.shopifyVariantId).split('/').pop(), 10);
      if (vid) VID = vid;
      if (up.id) PROPS.__essential_cart_drawer_order_upsell_id = up.id;
      if (cart && cart.id) PROPS.__essential_cart_drawer_upsell_id = cart.id;
    } catch (e) { /* keep the literals */ }
  }
  readAppConfig();
  var MARK = 'X-LJ-Protect';
  var busy = false, again = false, timer = null, switching = 0;

  function call(url, body) {
    var h = { Accept: 'application/json' }; h[MARK] = '1';
    if (body) h['Content-Type'] = 'application/json';
    return fetch(url, { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: h, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { return r.json(); });
  }

  function ensure() {
    if (busy) { again = true; return; }
    busy = true;
    call('/cart.js').then(function (cart) {
      var old = cart.items.filter(function (i) { return i.variant_id === OLD; });
      if (old.length) return call('/cart/change.js', { id: old[0].key, quantity: 0 }).then(refresh);
      var prot = cart.items.filter(function (i) { return i.variant_id === VID; });
      var others = cart.items.filter(function (i) { return i.variant_id !== VID; });
      var a = cart.attributes || {};
      if (!others.length) {
        if (a._lj_protect_added || a._lj_protect_off) return call('/cart/update.js', { attributes: { _lj_protect_added: '', _lj_protect_off: '' } });
        return;
      }
      if (prot.length > 1 || (prot.length && !prot[0].properties.__essential_cart_drawer_order_upsell_id)) {   // keep one line, the app's own
        var drop = prot.filter(function (i) { return !i.properties.__essential_cart_drawer_order_upsell_id; }).concat(prot.filter(function (i) { return i.properties.__essential_cart_drawer_order_upsell_id; }).slice(1));
        if (drop.length === prot.length) drop = drop.slice(1);
        if (drop.length) return call('/cart/change.js', { id: drop[0].key, quantity: 0 }).then(refresh);
      }
      if (prot.length) {
        if (prot[0].quantity > 1) return call('/cart/change.js', { id: prot[0].key, quantity: 1 }).then(refresh);
        // "added" is only written once the line is really in the cart, so leaving the page halfway never reads as "switched off"
        if (a._lj_protect_off === '1' || a._lj_protect_added !== '1') return call('/cart/update.js', { attributes: { _lj_protect_added: '1', _lj_protect_off: '' } });
        return;
      }
      if (a._lj_protect_off === '1') return;
      if (a._lj_protect_added === '1') return call('/cart/update.js', { attributes: { _lj_protect_off: '1' } });   // switched off
      if (Date.now() - switching < 12000) return;   // a switch-on is still on its way
      switching = Date.now();
      switchOn();
    }).catch(function () {}).then(function () {
      busy = false;
      if (again) { again = false; schedule(); }
    });
  }

  // Turn the drawer's own toggle on, so the app adds the line itself and shows the toggle as ON (a line added by us
  // would be charged while the toggle still looked OFF). The drawer opens on add to cart; if it is not drawn yet, retry,
  // and after ~10 s add the line with the app's properties instead.
  function switchOn(tries) {
    tries = tries || 0;
    var btn = document.querySelector('[data-essential-cart-element="order-upsell-item"] button[aria-pressed]');
    if (btn) { if (btn.getAttribute('aria-pressed') === 'false') btn.click(); return; }
    if (tries < 15) { setTimeout(function () { switchOn(tries + 1); }, 700); return; }
    // The app marks its own cart with this attribute; without it the toggle shows OFF over a line that is charged.
    return call('/cart/add.js?essential-cart-drawer', { items: [{ id: VID, quantity: 1, properties: PROPS }] })
      .then(function () { return call('/cart/update.js?essential-cart-drawer', { attributes: { __essential_cart_drawer: PROPS.__essential_cart_drawer_upsell_id } }); })
      .then(refresh);
  }

  // The drawer title counts every line ("Cart 2" for one ring + the hidden protection): show the pieces only.
  function fixTitle() {
    var t = document.getElementById('cart-drawer-title'), api = window.essentialCartApi;
    var d = api && api.getCartData();
    if (!t || !d || !d.items) return;
    var p = d.items.filter(function (i) { return i.variant_id === VID; }).reduce(function (n, i) { return n + i.quantity; }, 0);
    var m = t.textContent.trim().match(/^(\D*?)(\d+)$/);   // "Cart 2" / "Panier 2": the app's own word, any language
    if (!p || !m) return;
    var want = m[1] + (d.item_count - p);
    if (t.textContent !== want) t.textContent = want;
  }
  new MutationObserver(fixTitle).observe(document.documentElement, { subtree: true, childList: true, characterData: true });

  // Let the drawer redraw after a change it did not make itself, so its toggle shows the real state.
  function refresh() { if (window.essentialCartApi) return window.essentialCartApi.refreshCart(); document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }

  function schedule() { clearTimeout(timer); timer = setTimeout(ensure, 400); }

  // Every cart change (theme, Essential drawer via Ajax or Storefront API) triggers a check; our own calls carry MARK.
  var orig = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var mine = init && init.headers && init.headers[MARK];
    var p = orig.apply(this, arguments);
    if (!mine && (/\/cart\/(add|change|update|clear)/.test(url) || (/graphql/.test(url) && init && typeof init.body === 'string' && /cartLines|cartCreate/.test(init.body)))) {
      p.then(schedule, schedule);
    }
    return p;
  };
  // The drawer's own event as well (its toggle and quantity buttons), once the app is up.
  var hook = setInterval(function () { if (window.essentialCartApi) { clearInterval(hook); window.essentialCartApi.onCartUpdate(schedule); } }, 500);
  setTimeout(function () { clearInterval(hook); }, 20000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
